export default __webpack_public_path__ + "static/media/i_bus-low_rd.d98f9746.svg";